import React, { useEffect, useState } from 'react';
import { Container, Grid, Button, Typography } from '@mui/material';
import Page from '../../../components/Page';
import { useNavigate } from 'react-router-dom';
import { TextField } from 'src/components';
import { Select } from 'src/components';
import { useFormik } from 'formik';
import palette from 'src/theme/palette';
import { addstudentBehaviourSchema, addClassSchema } from 'src/validations/teacher';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { classService } from 'src/services/class.service';
import { teacherService } from 'src/services/teacher.service';
import { CreateClassDTO } from 'src/types/class.types';
import { Teacher } from 'src/types/teacher.types';
import { toast } from 'react-toastify';

export default function AddNewClass() {
  const navigate = useNavigate();

  const createClass = async (dto: CreateClassDTO): Promise<{ id: string }> => {
    return classService.createClass(dto);
  };

  const mutation: UseMutationResult<{ id: string }, Error, CreateClassDTO> = useMutation({
    mutationFn: createClass,
    onSuccess: (data) => {
      formik.resetForm();
      navigate('/admin/classes');
      toast.success('Class created successfully!');
    },
    onError: (error) => {
      console.error('Error creating class:', error);
      toast.error('Failed to create class. Please try again.');
    },
  });

  const [teachers, setTeachers] = useState<Teacher[]>([]);
  const [isLoadingTeachers, setIsLoadingTeachers] = useState<boolean>(true);

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await teacherService.getTeachers();
        setTeachers(response.data);
      } catch (error) {
        console.error('Failed to fetch teachers:', error);
      } finally {
        setIsLoadingTeachers(false);
      }
    };
    fetchTeachers();
  }, []);

  const formik = useFormik({
    initialValues: {
      title: '',
      startTime: '',
      endTime: '',
      teacherid: '',
    },
    validationSchema: addClassSchema,
    onSubmit: (values) => {
      mutation.mutate({ ...values, teacherid: values.teacherid } as CreateClassDTO);
    },
  });

  const selectedTeacher = teachers.find((teacher) => teacher.id === formik.values.teacherid);

  return (
    <Page title="Add New Student">
      <Container className="_container" maxWidth={false}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Title"
                placeholder="Enter Title"
                value={formik.values.title}
                onChange={formik.handleChange}
                name="title"
                error={Boolean(formik.touched.title && formik.errors.title)}
                helperText={formik.touched.title && formik.errors.title}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Select
                onChange={(option) => formik.setFieldValue('teacherid', option)}
                value={formik.values.teacherid}
                options={teachers.map((teacher) => ({
                  label: `${teacher.user.firstname} ${teacher.user.lastname}`,
                  value: teacher.id,
                }))}
                label="Teacher"
                placeholder="Select Teacher"
                helperText={formik.touched.teacherid && formik.errors.teacherid}
                error={Boolean(formik.touched.teacherid && formik.errors.teacherid)}
              />
              {/* <div>
                <label>Teacher Name</label>
                <Select
                  options={teachers.map((teacher) => ({
                    label: `${teacher.user.firstname} ${teacher.user.lastname}`,
                    value: teacher.id,
                  }))}
                  placeholder="Select a teacher"
                  name="teacherid"
                  onChange={(option) => formik.setFieldValue('teacherid', option ? option.value : '')}
                  value={
                    selectedTeacher
                      ? {
                          label: `${selectedTeacher.user.firstname} ${selectedTeacher.user.lastname}`,
                          value: selectedTeacher.id,
                        }
                      : null
                  }
                  isLoading={isLoadingTeachers}
                  isDisabled={false} // Disable in edit mode
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: state.isFocused ? palette.common.white : palette.common.white,
                      minHeight: 55,
                      fontSize: 16,
                      boxShadow: 'none',
                      fontWeight: '700',
                      backgroundColor: palette.grey[400],
                      borderRadius: 12,
                      marginTop: 5,
                    }),
                    multiValue: (styles) => ({
                      ...styles,
                      backgroundColor: palette.primary.main,
                      borderRadius: 27,
                      color: palette.common.white,
                    }),
                    multiValueLabel: (styles) => ({
                      ...styles,
                      color: palette.common.white,
                      fontWeight: '400',
                    }),
                  }}
                />
                {formik.touched.teacherid && formik.errors.teacherid && (
                  <Typography color="error" variant="body2">
                    {formik.errors.teacherid}
                  </Typography>
                )}
              </div> */}
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Start Time"
                placeholder="Start Time"
                value={formik.values.startTime}
                onChange={formik.handleChange}
                name="startTime"
                type="time"
                error={Boolean(formik.touched.startTime && formik.errors.startTime)}
                helperText={formik.touched.startTime && formik.errors.startTime}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="End Time"
                placeholder="Start Time"
                value={formik.values.endTime}
                onChange={formik.handleChange}
                name="endTime"
                error={Boolean(formik.touched.endTime && formik.errors.endTime)}
                helperText={formik.touched.endTime && formik.errors.endTime}
                type="time"
              />
            </Grid>
          </Grid>
          <div className="_add_st_footer_row" style={{ marginTop: 15 }}>
            <Button
              variant="outlined"
              style={{ height: 48, color: 'var(--primary-main)', width: 120, margin: 5 }}
              onClick={() => navigate('/admin/classes')}
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary" style={{ height: 48, width: 120, margin: 5 }}>
              Add
            </Button>
          </div>
        </form>
      </Container>
    </Page>
  );
}
